import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import Container from "../Components/Container";
import Div from "../Components/Div";
import Li from "../Components/Li";
import MyButton from "../Components/MyButton";
import MyInput from "../Components/MyInput";
import MySnackBar from "../Components/MySnackBar";
import UpdateClientData from "../Components/UpdateClientData";
import LinkButton from "../Components/LinkButton";
import * as XLSX from "xlsx";
import useScrollPosition from "../customHooks/useScrollPosition";
import ConfirmDeleteModal from "../Components/ConfirmDeleteModal";
import useFetchUserData from "../customHooks/useFetchUserData";
import DataInput from "../Components/DataInput";
import Li2 from "../Components/Li2";
import ClientPartnerBinding from "../Components/ClientPartnerBinding";

const OPERATION_LOG_FIELD_LABELS = {
    balance: "Баланс",
    paidBootlesFor12: "Оплаченные талоны 12-литровых бутылей",
    paidBootlesFor19: "Оплаченные талоны 19-литровых бутылей",
};

const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export default function ClientPage() {
    const scrollPosition = useScrollPosition();
    const { id } = useParams();
    const navigate = useNavigate();
    const userData = useFetchUserData();
    const [client, setClient] = useState({});
    const [modal, setModal] = useState(false)
    const [dates, setDates] = useState({
        startDate: "2024-01-01", // Начало месяца
        endDate: getCurrentDate()     // Сегодняшняя дата
    });
    const [denyVerification, setDenyVerification] = useState(false)
    const [denyVerificationMessage, setDenyVerificationMessage] = useState("")

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const showPartnerMessage = useCallback((text, messageStatus) => {
        setMessage(text);
        setStatus(messageStatus);
        setOpen(true);
    }, []);

    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [orders, setOrders] = useState([])

    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteModalClient, setDeleteModalClient] = useState(false)
    const [deleteObject, setDeleteObject] = useState(null)
    const [password, setPassword] = useState("")
    const [addPassword, setAddPassword] = useState(false)
    const [selectAddress, setSelectAddress] = useState(null)
    const [clientBottleCount, setClientBottleCount] = useState(0)
    const [clientBottleCredit, setClientBottleCredit] = useState(0)
    const [paidBootlesFor12, setPaidBootlesFor12] = useState(0)
    const [paidBootlesFor19, setPaidBootlesFor19] = useState(0)
    const [updatePaidBottlesModal, setUpdatePaidBottlesModal] = useState(false)
    const [balance, setBalance] = useState(0)
    const [secretCode, setSecretCode] = useState("")
    const [updateBalanceModal, setUpdateBalanceModal] = useState(false)
    const [changedBy, setChangedBy] = useState("")
    const [changeReason, setChangeReason] = useState("")
    const [operationLog, setOperationLog] = useState([])
    const [editingLogId, setEditingLogId] = useState(null)
    const [editLogChangedBy, setEditLogChangedBy] = useState("")
    const [editLogReason, setEditLogReason] = useState("")

    const [needVerification, setNeedVerification] = useState(false)

    const [invLegal, setInvLegal] = useState("")

    const [basis, setBasis] = useState("оферта")
    const [contractNumber, setContractNumber] = useState("")

    const [notes, setNotes] = useState("")

    const closeSnack = () => {
        setOpen(false);
    };

    const [updates, setUpdates] = useState({
        fullNameOpen: false,
        fullNameStr: "",
        userNameOpen: false,
        userNameStr: "",
        phoneOpen: false,
        phoneStr: "",
        mailOpen: false,
        mailStr: "",
        price12Open: false,
        price12Str: "",
        price19Open: false,
        price19Str: "",
    });

    const [addAdress, setAddAdress] = useState(false);

    const [newAdress, setNewAdress] = useState({
        name: "",
        city: "",
        street: "",
        link: "",
        apartment: "",
        floor: "",
        exactLink: "",
        phone: "",
        images: [],
        point: {
            lat: "",
            lon: ""
        }
    });
    const [imageUploading, setImageUploading] = useState(false);

    const apiOrigin = (process.env.REACT_APP_PORT || "").replace(/\/$/, "");

    const getImageSrc = (url) => {
        if (!url) return "";
        if (url.startsWith("http")) return url;
        return `${apiOrigin}${url.startsWith("/") ? url : `/${url}`}`;
    };

    const handleAddressImageUpload = async (event, target) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setImageUploading(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            const { data } = await api.post("/api/upload-address-image", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (data?.success && data?.url) {
                if (target === "edit") {
                    setSelectAddress((prev) => ({
                        ...prev,
                        images: [...(prev?.images || []), data.url],
                    }));
                } else {
                    setNewAdress((prev) => ({
                        ...prev,
                        images: [...(prev?.images || []), data.url],
                    }));
                }
            } else {
                setOpen(true);
                setStatus("error");
                setMessage(data?.message || "Не удалось загрузить изображение");
            }
        } catch (e) {
            console.log(e);
            setOpen(true);
            setStatus("error");
            setMessage("Не удалось загрузить изображение");
        } finally {
            setImageUploading(false);
            event.target.value = "";
        }
    };

    const removeAddressImage = (url, target) => {
        if (target === "edit") {
            setSelectAddress((prev) => ({
                ...prev,
                images: (prev?.images || []).filter((img) => img !== url),
            }));
        } else {
            setNewAdress((prev) => ({
                ...prev,
                images: (prev?.images || []).filter((img) => img !== url),
            }));
        }
    };

    const renderAddressImagesBlock = (images, target) => (
        <div className="flex flex-col gap-2 w-full mt-2">
            <div>Фото адреса:</div>
            {(images || []).length > 0 && (
                <div className="flex flex-wrap gap-2">
                    {(images || []).map((url, imageIndex) => (
                        <div key={`${url}-${imageIndex}`} className="relative">
                            <img
                                src={getImageSrc(url)}
                                alt={`address-${imageIndex}`}
                                className="w-20 h-20 object-cover rounded border border-gray-200"
                            />
                            <button
                                type="button"
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6"
                                onClick={() => removeAddressImage(url, target)}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <input
                type="file"
                accept="image/*"
                onChange={(event) => handleAddressImageUpload(event, target)}
                disabled={imageUploading}
            />
            {imageUploading && <div className="text-sm text-gray-500">Загрузка...</div>}
        </div>
    );

    const handleDateChange = (e) => {
        let input = e.target.value.replace(/\D/g, ""); // Remove all non-digit characters
        if (input.length > 8) input = input.substring(0, 8); // Limit input to 8 digits

        const year = input.substring(0, 4);
        const month = input.substring(4, 6);
        const day = input.substring(6, 8);

        let formattedValue = year;
        if (input.length >= 5) {
            formattedValue += "-" + month;
        }
        if (input.length >= 7) {
            formattedValue += "-" + day;
        }

        setDates({ ...dates, [e.target.name]: formattedValue });
    };

    const addressChangeHandler = (event) => {
        const streetValue = event.target.value;
        setNewAdress({
            ...newAdress,
            street: streetValue,
            link: generate2GISLink(streetValue),
        });
    };

    const closeConfirmModalAdd = () => {
        setModal(false)
    }

    const confirmDeleteAdd = () => {
        setAddAdress(true)
        setModal(false)
    }


    const generate2GISLink = (address) => {
        const encodedAddress = encodeURIComponent(address);
        return `https://2gis.kz/almaty/search/${encodedAddress}`;
    };

    const handleChangesUpdates = (title, value) => {
        setUpdates({
            ...updates,
            [title]: value,
        });
    };

    const changeHandler = (event) => {
        const { name, value } = event.target;
        
        // Обрабатываем вложенные поля point.lat и point.lon
        if (name.startsWith('point.')) {
            const pointField = name.split('.')[1]; // получаем 'lat' или 'lon'
            setSelectAddress({ 
                ...selectAddress, 
                point: {
                    ...selectAddress.point,
                    [pointField]: value
                }
            });
        } else {
            setSelectAddress({ ...selectAddress, [name]: value });
        }
    };

    const getClientData = () => {
        api.post(
            "/getClientDataForId",
            { id },
            { headers: { "Content-Type": "application/json" } }
        )
            .then(({ data }) => {
                setClient(data);
                setPaidBootlesFor12(data?.paidBootlesFor12)
                setPaidBootlesFor19(data?.paidBootlesFor19)
                setBalance(data?.balance)
                // Проверяем координаты всех адресов
                const hasInvalidCoordinates = data.addresses?.some(address => 
                    address == null ||
                    !address.point?.lat || 
                    !address.point?.lon || 
                    address.point.lat === null || 
                    address.point.lon === null
                );
                
                setNeedVerification(hasInvalidCoordinates);
                
                setUpdates({
                    fullNameOpen: false,
                    fullNameStr: data?.fullName,
                    userNameOpen: false,
                    userNameStr: data?.userName,
                    phoneOpen: false,
                    phoneStr: data?.phone,
                    mailOpen: false,
                    mailStr: data?.mail,
                    price12Open: false,
                    price12Str: data?.price12,
                    price19Open: false,
                    price19Str: data?.price19,
                });
                {
                    const ild = data?.invoiceLegalData
                    if (typeof ild === "string") {
                        setInvLegal(ild)
                    } else if (ild && typeof ild === "object") {
                        setInvLegal(
                            [ild.binIin, ild.legalName, ild.legalAddress, ild.invoicePhone]
                                .map((x) => (x != null ? String(x) : ""))
                                .map((s) => s.trim())
                                .filter(Boolean)
                                .join(", ")
                        )
                    } else {
                        setInvLegal("")
                    }
                }
                setNotes(typeof data?.notes === "string" ? data.notes : "")
                setBasis(data?.basis === "договор" ? "договор" : "оферта")
                setContractNumber(typeof data?.contractNumber === "string" ? data.contractNumber : "")
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const getOperationLog = () => {
        api.post(
            "/getClientOperationLog",
            { clientId: id },
            { headers: { "Content-Type": "application/json" } }
        )
            .then(({ data }) => {
                if (data.success) {
                    setOperationLog(data.logs || []);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const startEditingLogEntry = (entry) => {
        setEditingLogId(entry._id);
        setEditLogChangedBy(entry.changedBy || "");
        setEditLogReason(entry.reason || "");
    };

    const cancelEditingLogEntry = () => {
        setEditingLogId(null);
        setEditLogChangedBy("");
        setEditLogReason("");
    };

    const updateOperationLogEntry = () => {
        if (!editLogChangedBy.trim() || !editLogReason.trim()) {
            setOpen(true);
            setStatus("error");
            setMessage("Укажите, кто вносит изменение и по какой причине");
            return;
        }
        api.post(
            "/updateClientOperationLog",
            { logId: editingLogId, changedBy: editLogChangedBy, reason: editLogReason },
            { headers: { "Content-Type": "application/json" } }
        )
            .then(({ data }) => {
                if (data.success) {
                    setOpen(true);
                    setStatus("success");
                    setMessage(data.message);
                    cancelEditingLogEntry();
                    getOperationLog();
                }
            })
            .catch((e) => {
                console.log(e);
                setOpen(true);
                setStatus("error");
                setMessage(e?.response?.data?.message || "Не удалось изменить запись журнала");
            });
    };

    useEffect(() => {
        getClientData();
        getOperationLog();
    }, []);

    const deleteAdress = (id) => {
        api.post(
            "/deleteClientAdress",
            { clientId: client._id, adressId: id },
            {
                headers: { "Content-Type": "application/json" },
            }
        )
            .then(({ data }) => {
                if (data.success) {
                    setOpen(true);
                    setStatus("success");
                    setMessage(data.message);
                    getClientData();
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const clientAddPassword = (password) => {
        api.post(
            "/clientAddPassword",
            { clientId: client._id, password },
            {
                headers: { "Content-Type": "application/json" },
            }
        )
            .then(({ data }) => {
                if (data.success) {
                    setOpen(true);
                    setStatus("success");
                    setMessage(data.message);
                    setPassword("")
                    setAddPassword(false)
                    getClientData(); // обновляем данные клиента после успешного обновления
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const updateClientData = (field, value, extra = {}) => {
        let field2 = field
        if (field === "addresses") {
            const sendAddress = {
                name: value?.name || "",
                city: value?.city || "",
                street: value?.street || "",
                apartment: value?.apartment || "",
                floor: value?.floor || "",
                link: value?.exactLink || "",
                phone: value?.phone || "",
                images: value?.images || [],
                point: {
                    lat: value?.point?.lat || "",
                    lon: value?.point?.lon || ""
                }
            }

            value = [...(client.addresses || []), sendAddress]
        }
        if (field === "addresses2") {
            field2 = "addresses"
        }

        api.post(
            "/updateClientData",
            { clientId: client._id, field: field2, value, ...extra },
            {
                headers: { "Content-Type": "application/json" },
            }
        )
            .then(({ data }) => {
                if (data.success) {
                    if (field === "addresses") {
                        setAddAdress(false);
                    }
                    setOpen(true);
                    setStatus("success");
                    setMessage(data.message);
                    getClientData(); // обновляем данные клиента после успешного обновления
                    getOperationLog();
                    setSelectAddress(null)
                }
            })
            .catch((e) => {
                console.log(e);
                setOpen(true);
                setStatus("error");
                setMessage(e?.response?.data?.message || "Не удалось изменить данные");
            });
    };

    const deleteClient = () => {
        api.post(
            "/deleteClientAdmin",
            { id: client._id },
            {
                headers: { "Content-Type": "application/json" },
            }
        )
            .then(({ data }) => {
                if (data.success) {
                    setDeleteModalClient(false)
                    navigate(-1)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const loadMoreOrders = useCallback(async (page, dates) => {
        if (dates.startDate.length !== 10 || dates.endDate.length !== 10) {
            setOpen(true);
            setStatus("error");
            setMessage("Введите даты в формате ГГГГ-ММ-ДД");
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post(
                "/getClientOrders",
                {
                    page,
                    clientId: client?._id,
                    ...dates
                },
                {
                    headers: { "Content-Type": "application/json" },
                }
            );
    
            if (data.orders.length === 0) {
                setHasMore(false);
            } else {
                setOrders((prevOrders) => {
                    const existingOrderIds = new Set(prevOrders.map(order => order._id));
                    const newOrders = data.orders.filter(order => !existingOrderIds.has(order._id));
                    return [...prevOrders, ...newOrders];
                });
                setPage(page + 1);
            }
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    }, [page, loading, hasMore, client]);

    useEffect(() => {
        console.log("useEffect triggered with hasMore:", hasMore);
        if (hasMore && Object.keys(client).length > 0) {
            loadMoreOrders(page, dates);
        }
    }, [client, hasMore]);

    const observer = useRef();
    const lastOrderElementRef = useCallback(
        (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    loadMoreOrders(page, dates);
                }
            });
            if (node) observer.current.observe(node);
        },
        [loading, hasMore, loadMoreOrders]
    );

    const getClientOrdersForExcel = () => {
        api.post(
            "/getClientOrdersForExcel",
            {
                clientId: client._id,
                ...dates
            },
            {
                headers: { "Content-Type": "application/json" },
            }
        )
            .then(({ data }) => {
                const type = "orders";
                const orders = data.orders;

                const mappedData = orders.map((item) => {
                    return {
                        "Имя Клиента": item?.client?.fullName,
                        "Имя Пользователя": item?.client?.userName,
                        "Телефон": item?.client?.phone,
                        Адрес: item?.address?.actual,
                        "Кол18,9": item?.products?.b19 && item?.products?.b19 !== 0 ? item?.products?.b19 : "",
                        "Кол12,5": item?.products?.b12 && item?.products?.b12 !== 0 ? item?.products?.b12 : "",
                        "Форма оплаты": item?.opForm,
                        Сумма: item?.sum,
                        Курьер: item?.courier?.fullName || "",
                        "Курьер Агрегатор": item?.courierAggregator?.fullName || "",
                        Статус: "Доставлен",
                        "Дата доставки": item.date.d,
                    };
                });

                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(mappedData);
                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    type === "clients" ? "Clients" : "Orders"
                );
                const clientName = client.fullName
                const fileName = `${clientName}.xlsx`; // Убедитесь, что функция formatDate определена и возвращает строку

                XLSX.writeFile(workbook, fileName);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const confirmDelete = () => {
        deleteAdress(deleteObject)
        setDeleteModal(false)
        setDeleteObject(null)
    }

    const confirmDeleteClient = () => {
        deleteClient()
    }

    const closeConfirmModal = () => {
        setDeleteModal(false)
        setDeleteObject(null)
    }

    const closeConfirmModalClient = () => {
        setDeleteModalClient(false)
    }

    return (
        <div className="relative">
            {deleteModal && <ConfirmDeleteModal
                closeConfirmModal={closeConfirmModal}
                confirmDelete={confirmDelete}
                scrollPosition={scrollPosition}
            />}
            {deleteModalClient && <ConfirmDeleteModal
                closeConfirmModal={closeConfirmModalClient}
                confirmDelete={confirmDeleteClient}
                scrollPosition={scrollPosition}
            />}
            {modal && <ConfirmDeleteModal
                closeConfirmModal={closeConfirmModalAdd}
                confirmDelete={confirmDeleteAdd}
                scrollPosition={scrollPosition}
                add={true}
            />}
            {updatePaidBottlesModal &&
                <div
                    onClick={() => {
                        setUpdatePaidBottlesModal(false)
                    }}
                    className="absolute inset-0 bg-black bg-opacity-80"
                    style={{ minHeight: scrollPosition }} >
                    <div
                        className="absolute left-1/2 transform -translate-x-1/2 flex items-center justify-center bg-black bg-opacity-80"
                        style={{ top: scrollPosition + 50 }}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            className="relative px-8 py-4 border border-red rounded-md"
                        >
                            <div className="flex flex-col gap-y-2">
                                <div className="text-white text-sm">Код подтверждения:</div>
                                <MyInput
                                    value={secretCode}
                                    change={(e) => {setSecretCode(e.target.value)}}
                                    color="white"
                                />
                                <div className="text-white text-sm">Кто вносит изменение:</div>
                                <MyInput
                                    value={changedBy}
                                    change={(e) => {setChangedBy(e.target.value)}}
                                    color="white"
                                    textColor="white"
                                />
                                <div className="text-white text-sm">Причина изменения:</div>
                                <MyInput
                                    value={changeReason}
                                    change={(e) => {setChangeReason(e.target.value)}}
                                    color="white"
                                    textColor="white"
                                />
                                <MyButton click={() => {
                                    if (secretCode !== process.env.REACT_APP_SECRET_CODE) {
                                        setOpen(true);
                                        setStatus("error");
                                        setMessage("Неверный код");
                                        setSecretCode("")
                                        return
                                    }
                                    if (!changedBy.trim() || !changeReason.trim()) {
                                        setOpen(true);
                                        setStatus("error");
                                        setMessage("Укажите, кто вносит изменение и по какой причине");
                                        return
                                    }
                                    setUpdatePaidBottlesModal(false)
                                    updateClientData("paidBootlesFor19", paidBootlesFor19, { changedBy, reason: changeReason })
                                    updateClientData("paidBootlesFor12", paidBootlesFor12, { changedBy, reason: changeReason })
                                    updateClientData("paymentMethod", "coupon")
                                    setSecretCode("")
                                    setChangedBy("")
                                    setChangeReason("")
                                }}>Подтвердить</MyButton>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {updateBalanceModal &&
                <div
                    onClick={() => {
                        setUpdateBalanceModal(false)
                    }}
                    className="absolute inset-0 bg-black bg-opacity-80"
                    style={{ minHeight: scrollPosition }} >
                    <div
                        className="absolute left-1/2 transform -translate-x-1/2 flex items-center justify-center bg-black bg-opacity-80"
                        style={{ top: scrollPosition + 50 }}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            className="relative px-8 py-4 border border-red rounded-md"
                        >
                            <div className="flex flex-col gap-y-2">
                                <div className="text-white text-sm">Код подтверждения:</div>
                                <MyInput
                                    value={secretCode}
                                    change={(e) => {setSecretCode(e.target.value)}}
                                    color="white"
                                />
                                <div className="text-white text-sm">Кто вносит изменение:</div>
                                <MyInput
                                    value={changedBy}
                                    change={(e) => {setChangedBy(e.target.value)}}
                                    color="white"
                                />
                                <div className="text-white text-sm">Причина изменения:</div>
                                <MyInput
                                    value={changeReason}
                                    change={(e) => {setChangeReason(e.target.value)}}
                                    color="white"
                                />
                                <MyButton click={() => {
                                    if (secretCode !== process.env.REACT_APP_SECRET_CODE) {
                                        setOpen(true);
                                        setStatus("error");
                                        setMessage("Неверный код");
                                        setSecretCode("")
                                        return
                                    }
                                    if (!changedBy.trim() || !changeReason.trim()) {
                                        setOpen(true);
                                        setStatus("error");
                                        setMessage("Укажите, кто вносит изменение и по какой причине");
                                        return
                                    }
                                    setUpdateBalanceModal(false)
                                    updateClientData("balance", balance, { changedBy, reason: changeReason })
                                    setSecretCode("")
                                    setChangedBy("")
                                    setChangeReason("")
                                }}>Подтвердить</MyButton>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <Container role={userData?.role}>
                <Div>Карточка клиента</Div>
                {userData?.role === "superAdmin" && needVerification && <>
                    <Div />
                    <Div>
                        <div className="text-red font-medium text-xl">Нужна верификация, у адресов нет координат</div>
                    </Div>
                </>}
                <Div />
                {userData?.role === "superAdmin" && <>
                    <Div>Франчайзи: {client?.franchisee?.fullName}</Div>
                    <Div/>
                </>}
                <Div>Личные данные:</Div>
                <>
                    <Div>Платформа: {client?.platform || "Не указана"}</Div>
                    <Div>Версия приложения: {client?.appVersion || "Не указана"}</Div>
                    <UpdateClientData
                        title="Наименование"
                        open={updates.fullNameOpen}
                        str={updates.fullNameStr}
                        name="fullName"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                    <UpdateClientData
                        title="Контактное лицо"
                        open={updates.userNameOpen}
                        str={updates.userNameStr}
                        name="userName"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                    <UpdateClientData
                        title="Телефон"
                        open={updates.phoneOpen}
                        str={updates.phoneStr}
                        name="phone"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                    <UpdateClientData
                        title="Email"
                        open={updates.mailOpen}
                        str={updates.mailStr}
                        name="mail"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                    <Li>
                        <div>Пароль:</div>
                        {addPassword && <>
                            <MyInput
                                color="red"
                                value={password}
                                change={(e) => {
                                    setPassword(e.target.value);
                                }}
                            />
                        </>}
                        {addPassword ? <div className="flex items-center gap-x-2 text-green-400">
                            <div>[</div>
                            <button className="text-green-400 hover:text-blue-500" onClick={() => {clientAddPassword(password)}}>Сохранить</button>
                            <div>/</div>
                            <button className="text-green-400 hover:text-blue-500" onClick={() => {setAddPassword(false)}}>Отменить</button>
                            <div>]</div>
                        </div> : <>
                            <MyButton click={() => {
                                setAddPassword(true)
                            }}>{client?.password ? "Изменить" : "Добавить"}</MyButton>
                        </>}
                        
                    </Li>
                    <Li>
                        <div>Тип клиента: <span className="text-yellow-400">{client?.clientType ? "Физ лицо" : "Юр лицо"}</span></div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("clientType", true)}}>Физ лицо</button>
                                <div>/</div>
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("clientType", false)}}>Юр лицо</button>
                            ]
                        </div>
                    </Li>
                    {userData?.role === "superAdmin" && <>
                    <Li>
                        <div>Тип бутылки: <span className="text-yellow-400">{client?.clientBottleType}</span></div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("clientBottleType", 1)}}>1</button>
                                <div>/</div>
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("clientBottleType", 7)}}>7</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Кол-во бутылок: <span className="text-yellow-400">{client?.clientBottleCount}</span></div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            <MyInput
                                value={clientBottleCount}
                                change={(e) => {setClientBottleCount(e.target.value)}}
                                color="white"
                            />
                            <MyButton click={() => {updateClientData("clientBottleCount", clientBottleCount)}}>Сохранить</MyButton>
                        </div>
                    </Li>
                    <Li>
                        <div>Долг по бутылям: <span className="text-yellow-400">{client?.clientBottleCredit}</span></div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            <MyInput
                                value={clientBottleCredit}
                                change={(e) => {setClientBottleCredit(e.target.value)}}
                                color="white"
                            />
                            <MyButton click={() => {updateClientData("clientBottleCredit", clientBottleCredit)}}>Сохранить</MyButton>
                        </div>
                    </Li>
                    <Div>Последние пустые бутылки: </Div>
                    <Li>
                        <div>12.5-литровых бутылей: {client?.emptyBottles?.b12 || 0}</div>
                    </Li>
                    <Li>
                        <div>18.9-литровых бутылей: {client?.emptyBottles?.b19 || 0}</div>
                    </Li>
                    </>}
                </>

                <Div />
                <Div>
                    <div>Форма оплаты: <span className="text-yellow-300">{client?.opForm === "fakt" && "Нал_QR"}{client?.opForm === "postpay" && "Постоплата"}{client?.opForm === "credit" && "Карта"}{client?.opForm === "coupon" && "Талоны"}{client?.opForm === "mixed" && "Смешанная"}</span></div>
                </Div>
                <div className="hidden lg:block">
                    <Div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "fakt")}}>Нал_QR</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "coupon")}}>Талоны</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "postpay")}}>Постоплата</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "credit")}}>Карта</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "mixed")}}>Смешанная</button>
                            ]
                        </div>
                    </Div>
                </div>

                <div className="lg:hidden">
                    <Div>
                        <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "fakt")}}>Нал_QR</button>
                    </Div>
                    <Div>
                        <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "coupon")}}>Талоны</button> 
                    </Div>
                    <Div>
                        <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "postpay")}}>Постоплата</button> 
                    </Div>
                    <Div>
                        <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "credit")}}>Карта</button>
                    </Div>
                    <Div>
                        <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("opForm", "mixed")}}>Смешанная</button>
                    </Div>
                </div>

                {userData?.role === "superAdmin" && <>
                    <Li>
                        <div>Баланс: <span className="text-yellow-400">{client?.balance || 0}</span></div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            <MyInput
                                value={balance}
                                change={(e) => {setBalance(e.target.value)}}
                                color="white"
                            />
                            <MyButton click={() => {setUpdateBalanceModal(true)}}>Сохранить</MyButton>
                        </div>
                    </Li>
                    <Li>
                        <div>Кол-во оплаченных талонов 12-литровых бутылей : {client?.paidBootlesFor12 || 0}</div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            <MyInput
                                value={paidBootlesFor12}
                                change={(e) => {setPaidBootlesFor12(e.target.value)}}
                                color="white"
                            />
                        </div>
                    </Li>
                    <Li>
                        <div>Кол-во оплаченных талонов 19-литровых бутылей: {client?.paidBootlesFor19 || 0}</div>
                        <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                            <MyInput
                                value={paidBootlesFor19}
                                change={(e) => {setPaidBootlesFor19(e.target.value)}}
                                color="white"
                            />
                            <MyButton click={() => {setUpdatePaidBottlesModal(true)}}>Сохранить</MyButton>
                        </div>
                    </Li>
                    <Li>
                        <div>Метод оплаты: <span className="text-yellow-400">{client?.paymentMethod === "balance" ? "Баланс" : "Талоны"}</span></div>
                        <div className="text-yellow-400 flex items-center gap-x-3">
                            [
                                <button className="text-yellow-400 hover:text-blue-500" onClick={() => {updateClientData("paymentMethod", "balance")}}>Баланс</button> /
                                <button className="text-yellow-400 hover:text-blue-500" onClick={() => {updateClientData("paymentMethod", "coupon")}}>Талоны</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Журнал операций (баланс / талоны):</div>
                        <div className="flex flex-col gap-y-2 text-sm">
                            {operationLog.length === 0 && (
                                <div className="text-gray-400">Изменений не было</div>
                            )}
                            {operationLog.map((entry) => (
                                <div key={entry._id} className="border-b border-gray-700 pb-1">
                                    <div>
                                        {new Date(entry.createdAt).toLocaleString('ru-RU')}
                                    </div>
                                    <div>
                                        {OPERATION_LOG_FIELD_LABELS[entry.field] || entry.field}: {String(entry.oldValue ?? "—")} → {String(entry.newValue ?? "—")}
                                    </div>
                                    {editingLogId === entry._id ? (
                                        <div className="flex flex-col gap-y-1 mt-1">
                                            <div className="text-gray-400">Кто:</div>
                                            <MyInput
                                                value={editLogChangedBy}
                                                change={(e) => setEditLogChangedBy(e.target.value)}
                                                color="white"
                                            />
                                            <div className="text-gray-400">Причина:</div>
                                            <MyInput
                                                value={editLogReason}
                                                change={(e) => setEditLogReason(e.target.value)}
                                                color="white"
                                            />
                                            <div className="flex items-center gap-x-2">
                                                <MyButton click={updateOperationLogEntry}>Сохранить</MyButton>
                                                <MyButton click={cancelEditingLogEntry}>Отменить</MyButton>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex items-center gap-x-2 flex-wrap">
                                            <div>Кто: {entry.changedBy}</div>
                                            <div className="text-gray-400">Причина: {entry.reason}</div>
                                            <button
                                                className="text-green-400 hover:text-blue-500"
                                                onClick={() => startEditingLogEntry(entry)}
                                            >
                                                Изменить
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Li>
                    <Li>
                        <div>Берут ли 19-литровые бутыли: <span className="text-yellow-400">{client?.doesItTake19Bottles ? "Да" : "Нет"}</span></div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("doesItTake19Bottles", true)}}>Да</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("doesItTake19Bottles", false)}}>Нет</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Берут ли 12-литровые бутыли: <span className="text-yellow-400">{client?.doesItTake12Bottles ? "Да" : "Нет"}</span></div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("doesItTake12Bottles", true)}}>Да</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("doesItTake12Bottles", false)}}>Нет</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Блок «Ремонт техники» в приложении: <span className="text-yellow-400">{client?.showRepairMasterInApp !== false ? "Показывать" : "Скрыть"}</span></div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("showRepairMasterInApp", true)}}>Показывать</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("showRepairMasterInApp", false)}}>Скрыть</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Блокировка из-за АВР: <span className={client?.avrBlocked ? "text-red" : "text-yellow-400"}>{client?.avrBlocked ? "Да (заказы в приложении заблокированы)" : "Нет"}</span></div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("avrBlocked", true)}}>Да</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("avrBlocked", false)}}>Нет</button>
                            ]
                        </div>
                    </Li>
                    <Li>
                        <div>Оплата только онлайн: <span className="text-yellow-400">{client?.onlinePaymentOnly ? "Да (без оплаты наличными курьеру)" : "Нет"}</span></div>
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("onlinePaymentOnly", true)}}>Да</button> /
                                <button className="text-green-400 hover:text-blue-500" onClick={() => {updateClientData("onlinePaymentOnly", false)}}>Нет</button>
                            ]
                        </div>
                    </Li>
                </>}

                <Div />
                <Div>Адреса:</Div>
                {client.addresses &&
                    client.addresses.length > 0 &&
                    client.addresses.filter(adress => adress != null).map((adress, index) => {
                        return (
                            <>
                                <Li key={adress?._id}>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>
                                            Адрес{" "}
                                            <span className="text-red">
                                                {index + 1}
                                            </span>
                                            :
                                        </div>
                                        <div>
                                            {adress?.name || ""}, {adress?.street || ""} {adress?.floor ? `этаж ${adress?.floor}` : ""} {adress?.apartment ? `${client?.clientType ? "кв." : "офис"} ${adress?.apartment}` : ""}
                                        </div>
                                        <a
                                            href={adress?.link}
                                            target="_blank" rel="noreferrer"
                                            className="text-blue-500 hover:text-blue-500"
                                        >
                                            {adress?.link?.includes("/search") ? <>link%%{adress?.street || ""}</> : <>{adress?.link}</>}
                                        </a>
                                        {selectAddress?._id !== adress?._id && <>
                                            {adress?.images?.length > 0 && (
                                                <div className="flex flex-wrap gap-2">
                                                    {adress.images.map((url, imageIndex) => (
                                                        <img
                                                            key={`${adress?._id}-img-${imageIndex}`}
                                                            src={getImageSrc(url)}
                                                            alt={`address-preview-${imageIndex}`}
                                                            className="w-12 h-12 object-cover rounded border border-gray-200"
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            <MyButton
                                                click={() => {
                                                    setSelectAddress({ ...adress, images: adress?.images || [] })
                                                }}
                                            >
                                                Редактировать
                                            </MyButton>
                                            <MyButton
                                                click={() => {
                                                    setDeleteObject(adress?._id)
                                                    setDeleteModal(true)
                                                    // deleteClient(client._id);
                                                }}
                                            >
                                                Удалить
                                            </MyButton>
                                        </>}
                                        
                                    </div>
                                </Li>
                                {selectAddress?._id === adress?._id && <>
                                    <Li2>
                                        <div className="flex items-center gap-x-3 flex-wrap">
                                            <div>Наименование:</div>
                                            <MyInput
                                                name="name"
                                                value={selectAddress?.name || ""}
                                                change={changeHandler}
                                                color="white"
                                            />
                                        </div>
                                    </Li2>
                                    <Li2>
                                        <div className="flex items-center gap-x-3 flex-wrap">
                                            <div>Город:</div>
                                            <MyInput
                                                name="city"
                                                value={selectAddress?.city || ""}
                                                change={changeHandler}
                                                color="white"
                                            />
                                        </div>
                                    </Li2>
                                    <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap gap-y-2">
                                        <div>Улица, дом, под:</div>
                                        <MyInput
                                            name="street"
                                            value={selectAddress?.street || ""}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>{client?.clientType ? "Кв" : "Офис"}</div>
                                        <MyInput
                                            name={`apartment`}
                                            value={selectAddress.apartment}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>Этаж:</div>
                                        <MyInput
                                            name={`floor`}
                                            value={selectAddress.floor}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>Точная ссылка:</div>
                                        <MyInput
                                            name={`link`}
                                            value={selectAddress.link}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>Номер телефона:</div>
                                        <MyInput
                                            name={"phone"}
                                            value={selectAddress.phone}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    <div className="flex items-center gap-x-3 flex-wrap">
                                        <div>Координаты:</div>
                                        <MyInput
                                            name={"point.lat"}
                                            value={selectAddress?.point?.lat || ""}
                                            change={changeHandler}
                                            color="white"
                                        />
                                        <MyInput
                                            name={"point.lon"}
                                            value={selectAddress?.point?.lon || ""}
                                            change={changeHandler}
                                            color="white"
                                        />
                                    </div>
                                </Li2>
                                <Li2>
                                    {renderAddressImagesBlock(selectAddress?.images, "edit")}
                                </Li2>
                                <Li2>
                                    <div className="text-green-400">
                                        [
                                    </div>
                                    <button 
                                        className="text-green-400 hover:text-blue-500" 
                                        onClick={() => {
                                            const updatedAddresses = (client.addresses || []).map((address) =>
                                                address?._id === selectAddress?._id ? { ...selectAddress, images: selectAddress?.images || [] } : address
                                            );
                                            updateClientData("addresses2", updatedAddresses);
                                        }}
                                    >
                                        Сохранить
                                    </button>
                                    <div className="text-green-400">
                                        /
                                    </div>
                                    <button className="text-green-400 hover:text-blue-500" onClick={() => {setSelectAddress(null)}}>
                                        Отменить
                                    </button>
                                    <div className="text-green-400">
                                        ]
                                    </div>
                                </Li2>
                                </>}
                            </>
                        );
                    })}
                <>
                    {addAdress ? (
                        <>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap gap-y-2">
                                    <div>Название: (Дом, Работа, Дача)</div>
                                    <MyInput
                                        value={newAdress.name}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, name: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap gap-y-2">
                                    <div>Город:</div>
                                    <MyInput
                                        value={newAdress.city}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, city: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap gap-y-2">
                                    <div>Улица и дом:</div>
                                    <MyInput
                                        value={newAdress?.street}
                                        change={(event) =>
                                            addressChangeHandler(event)
                                        }
                                        color="white"
                                    />
                                    <div>
                                        2GIS ссылка:{" "}
                                        <a
                                            className="text-blue-500 hover:text-green-500"
                                            target="_blank" rel="noreferrer"
                                            href={newAdress?.link}
                                        >
                                            link%%{newAdress?.street}
                                        </a>
                                    </div>
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <div>Квартира/Офис/Кабинет:</div>
                                    <MyInput
                                        value={newAdress.apartment}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, apartment: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <div>Этаж:</div>
                                    <MyInput
                                        value={newAdress.floor}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, floor: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <div>Телефон:</div>
                                    <MyInput
                                        value={newAdress.phone}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, phone: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <div>Точная ссылка:</div>
                                    <MyInput
                                        value={newAdress.exactLink}
                                        change={(event) =>
                                            setNewAdress({ ...newAdress, exactLink: event.target.value })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <div>Координаты:</div>
                                    <MyInput
                                        value={newAdress.point.lat}
                                        change={(event) =>
                                            setNewAdress({ 
                                                ...newAdress, 
                                                point: {
                                                    ...newAdress.point,
                                                    lat: event.target.value
                                                }
                                            })
                                        }
                                        color="white"
                                    />
                                    <MyInput
                                        value={newAdress.point.lon}
                                        change={(event) =>
                                            setNewAdress({ 
                                                ...newAdress, 
                                                point: {
                                                    ...newAdress.point,
                                                    lon: event.target.value
                                                }
                                            })
                                        }
                                        color="white"
                                    />
                                </div>
                            </Li>
                            <Li>
                                {renderAddressImagesBlock(newAdress.images, "new")}
                            </Li>
                            <Li>
                                <div className="flex items-center gap-x-3 flex-wrap">
                                    <MyButton
                                        click={() => {
                                            updateClientData("addresses", newAdress);
                                            setNewAdress({
                                                name: "",
                                                city: "",
                                                street: "",
                                                apartment: "",
                                                floor: "",
                                                exactLink: "",
                                                phone: "",
                                                images: [],
                                                point: {
                                                    lat: "",
                                                    lon: ""
                                                }
                                            })
                                        }}
                                    >
                                        <span className="text-green-400">
                                        Сохранить
                                    </span>
                                    </MyButton>
                                    <MyButton
                                        click={() => {
                                            setAddAdress(false);
                                            setNewAdress({
                                                name: "",
                                                city: "",
                                                street: "",
                                                apartment: "",
                                                floor: "",
                                                exactLink: "",
                                                phone: "",
                                                images: [],
                                                point: {
                                                    lat: "",
                                                    lon: ""
                                                }
                                            })
                                        }}
                                    >
                                        <span className="text-green-400">
                                        Отменить
                                    </span>
                                    </MyButton>
                                </div>
                            </Li>
                        </>
                    ) : (
                        <Li>
                            <MyButton
                                click={() => {
                                    setModal(true)
                                }}
                            >
                                Добавить еще один адрес
                            </MyButton>
                        </Li>
                    )}
                </>
                {userData?.role === "admin" && <>
                    <Div />
                    <Div>
                        Верифицирован: {client?.verify && client?.verify?.status === "verified" ? "Да" : client?.verify?.status === "waitingVerification" ? "Ожидает верификации" : "Отказано в верификации"}
                    </Div>
                    <Div>
                        <MyButton click={() => {updateClientData("verify", {status: "verified", message: "success"})}}>Верифицировать</MyButton>
                    </Div>
                </>}
                {userData?.role === "superAdmin" && <>
                    <Div />
                    <Div>
                        Верифицирован: {client?.verify && client?.verify?.status === "verified" ? "Да" : client?.verify?.status === "waitingVerification" ? "Ожидает верификации" : "Отказано в верификации"}
                    </Div>
                    <Div>
                        <MyButton click={() => {updateClientData("verify", {status: "verified", message: "success"})}}>Верифицировать</MyButton>
                        <MyButton click={() => {setDenyVerification(true)}}>Отказать в верификации</MyButton>
                    </Div>
                    {denyVerification && <>
                        <Div>
                            Причина отказа:
                        </Div>
                        <Li>
                            <MyButton click={() => {
                                const DVM = denyVerificationMessage
                                if (DVM.includes("Не полный адрес")) {
                                    const updated = DVM.replace("Не полный адрес", "").trim();
                                    setDenyVerificationMessage(updated);
                                } else {
                                    const updated = (DVM + " Не полный адрес").trim();
                                    setDenyVerificationMessage(updated);
                                }
                            }}>{denyVerificationMessage.includes("Не полный адрес") ? "x" : " "}</MyButton>
                            <div>Не полный адрес</div>
                        </Li>
                        <Li>
                            <MyButton click={() => {
                                const DVM = denyVerificationMessage
                                if (DVM.includes("Отсутствует email")) {
                                    const updated = DVM.replace("Отсутствует email", "").trim();
                                    setDenyVerificationMessage(updated);
                                } else {
                                    const updated = (DVM + " Отсутствует email").trim();
                                    setDenyVerificationMessage(updated);
                                }
                            }}>{denyVerificationMessage.includes("Отсутствует email") ? "x" : " "}</MyButton>
                            <div>Отсутствует email</div>
                        </Li>
                        <Li>
                            <MyButton click={() => {
                                const DVM = denyVerificationMessage
                                if (DVM.includes("Нет имени контактного лица")) {
                                    const updated = DVM.replace("Нет имени контактного лица", "").trim();
                                    setDenyVerificationMessage(updated);
                                } else {
                                    const updated = (DVM + " Нет имени контактного лица").trim();
                                    setDenyVerificationMessage(updated);
                                }
                            }}>{denyVerificationMessage.includes("Нет имени контактного лица") ? "x" : " "}</MyButton>
                            <div>Нет имени контактного лица</div>
                        </Li>
                        <Li>
                            <MyButton click={() => {
                                const DVM = denyVerificationMessage
                                if (DVM.includes("Нет номера контактного лица")) {
                                    const updated = DVM.replace("Нет номера контактного лица", "").trim();
                                    setDenyVerificationMessage(updated);
                                } else {
                                    const updated = (DVM + " Нет номера контактного лица").trim();
                                    setDenyVerificationMessage(updated);
                                }
                            }}>{denyVerificationMessage.includes("Нет номера контактного лица") ? "x" : " "}</MyButton>
                            <div>Нет номера контактного лица</div>
                        </Li>
                        <Div />
                        <Li>
                            <MyButton click={() => {
                                if (denyVerificationMessage === "") {
                                    setOpen(true)
                                    setMessage("Добавьте описание отказа")
                                    setStatus("error")
                                } else {
                                    updateClientData("verify", {status: "denyVerification", message: denyVerificationMessage})
                                    setDenyVerification(false)
                                    setDenyVerificationMessage("")
                                }
                            }}>Принять</MyButton>
                            <MyButton click={() => {setDenyVerification(false)}}>Отменить</MyButton>
                        </Li>
                    </>}
                </>}

                <Div />
                <Div>Цены товаров:</Div>
                <>
                    <UpdateClientData
                        title="12,5-литровая бутыль"
                        open={updates.price12Open}
                        str={updates.price12Str}
                        name="price12"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                    <UpdateClientData
                        title="19,8-литровая бутыль"
                        open={updates.price19Open}
                        str={updates.price19Str}
                        name="price19"
                        handleChange={handleChangesUpdates}
                        client={client}
                        updateClientData={updateClientData}
                    />
                </>

                <Div />
                <Div>
                    Основание: <span className="text-yellow-300">{basis === "оферта" ? "Оферта" : `Договор № ${contractNumber || "—"}`}</span>
                </Div>
                <Li>
                    <div className="flex flex-col gap-y-2">
                        <div className="text-green-400 flex items-center gap-x-3">
                            [
                                <button className="hover:text-blue-500" onClick={() => {setBasis("оферта")}}>Оферта</button> /
                                <button className="hover:text-blue-500" onClick={() => {setBasis("договор")}}>Договор</button>
                            ]
                        </div>
                        {basis === "договор" && (
                            <div className="flex items-center gap-x-3">
                                <div>Номер договора:</div>
                                <input
                                    style={{ fontSize: "16px" }}
                                    value={contractNumber}
                                    onChange={(e) => setContractNumber(e.target.value)}
                                    className="bg-black text-white border border-white rounded-lg p-1 text-sm"
                                />
                            </div>
                        )}
                        <MyButton click={() => {
                            updateClientData("basis", basis, { contractNumber: basis === "договор" ? contractNumber : "" })
                        }}>Сохранить основание</MyButton>
                    </div>
                </Li>
                <Div />
                <Div>
                    Юр. данные для счёта:
                </Div>
                <Li>
                    <div className="flex flex-col gap-y-2">
                    <textarea size={13} style={{ fontSize: '16px' }} value={invLegal} onChange={(e) => {setInvLegal(e.target.value)}} className="bg-black text-white border border-white rounded-lg p-1 text-sm"></textarea>
                        <MyButton click={() => { updateClientData("invoiceLegalData", invLegal) }}>Сохранить юр. данные</MyButton>
                    </div>
                </Li>
                <Div />
                <Div>
                    Заметки:
                </Div>
                <Li>
                    <div className="flex flex-col gap-y-2">
                    <textarea size={13} style={{ fontSize: '16px' }} value={notes} onChange={(e) => {setNotes(e.target.value)}} className="bg-black text-white border border-white rounded-lg p-1 text-sm"></textarea>
                        <MyButton click={() => { updateClientData("notes", notes) }}>Сохранить заметки</MyButton>
                    </div>
                </Li>

                {userData?.role === "superAdmin" && (
                    <ClientPartnerBinding clientId={id} onMessage={showPartnerMessage} onClientUpdated={getClientData} />
                )}

                <Div />
                <Div>Сводная информация:</Div>
                <>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>Общее количество заказов:</div>
                            <div className="text-red"></div>
                        </div>
                    </Li>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>
                                Количество <span className="text-red">12.5</span>
                                -литровых бутылей:
                            </div>
                            <div className="text-red"></div>
                        </div>
                    </Li>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>
                                Количество <span className="text-red">18.9</span>
                                -литровых бутылей:
                            </div>
                            <div className="text-red"></div>
                        </div>
                    </Li>
                </>

                <Div />
                <Div>Настройки клиента:</Div>
                <>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>Выбор времени доставки: {client?.chooseTime ? "Включено" : "Отключено"}</div>
                            <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                                [
                                <button
                                    className="text-green-400 hover:text-blue-500"
                                    onClick={() => {updateClientData("chooseTime", true)}}
                                >
                                    Включить
                                </button>
                                <div>/</div>
                                <button
                                    className="text-green-400 hover:text-blue-500"
                                    onClick={() => {updateClientData("chooseTime", false)}}
                                >
                                    Отключить
                                </button>
                                ]
                            </div>
                        </div>
                    </Li>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>Подписка: {client?.subscription ? "Включено" : "Отключено"}</div>
                            <div className="flex items-center gap-x-2 flex-wrap text-green-400">
                                [
                                <button
                                    className="text-green-400 hover:text-blue-500"
                                    onClick={() => {updateClientData("subscription", true)}}
                                >
                                    Включить
                                </button>
                                <div>/</div>
                                <button
                                    className="text-green-400 hover:text-blue-500"
                                    onClick={() => {updateClientData("subscription", false)}}
                                >
                                    Отключить
                                </button>
                                ]
                            </div>
                        </div>
                    </Li>
                </>

                <Div />
                <Div>Фильтры:</Div>
                <>
                    <Li>
                        <div className="flex items-center gap-x-3 flex-wrap">
                            <div>Дата:</div>
                            <div className="text-red">
                                [
                                <DataInput
                                    color="red"
                                    value={dates.startDate}
                                    name="startDate"
                                    change={handleDateChange}
                                />
                                ]
                            </div>
                            <div> - </div>
                            <div className="text-red">
                                [
                                <DataInput
                                    color="red"
                                    value={dates.endDate}
                                    name="endDate"
                                    change={handleDateChange}
                                />
                                ]
                            </div>
                            <MyButton click={() => {
                                setOrders([]);
                                setPage(1);
                                setHasMore(true);
                                setLoading(false)                                
                                loadMoreOrders(1, dates)
                            }}>
                                <span className="text-green-400">
                                    Применить
                                </span>
                            </MyButton>
                        </div>
                    </Li>
                </>
                <Div />
                <Div>
                    <div>История заказов:</div>
                    {userData?.role === "superAdmin" &&
                        <LinkButton
                            color="green"
                            href={`/transferOrders/${client?._id}`}
                        >
                            Перенести заказы
                        </LinkButton>
                    }
                </Div>
                <div className="max-h-[100px] overflow-scroll">
                    {orders.map((item, index) => {
                        if (orders.length === index + 1) {
                            return (
                                <div key={item?._id} ref={lastOrderElementRef}>
                                    <Li>
                                        <div className="flex items-center gap-x-3 flex-wrap">
                                            <div>
                                                Заказ: 
                                            </div>
                                            <div>{item?.client?.fullName}</div>
                                            <a target="_blank" rel="noreferrer" href={item?.address?.link} className="text-blue-500 hover:text-green-500">{item?.address?.actual}</a>
                                            <div>{item?.date?.d} {item?.date?.time !== "" && item?.date?.time}</div>
                                            <div>{item?.products?.b12 !== 0 && `12.5л: ${item?.products?.b12}`}; {item?.products?.b19 !== 0 && `18.9л: ${item?.products?.b19}`}</div>
                                            <LinkButton
                                                href={`/orderPage/${item?._id}`}
                                            >
                                                Просмотр
                                            </LinkButton>
                                        </div>
                                    </Li>
                                </div>
                            );
                        } else {
                            return (
                                <div key={item?._id}>
                                    <Li>
                                        <div className="flex items-center gap-x-3 flex-wrap">
                                            <div>
                                                Заказ: 
                                            </div>
                                            <div>{item?.client?.fullName}</div>
                                            <a target="_blank" rel="noreferrer" href={item?.address?.link} className="text-blue-500 hover:text-green-500">{item?.address?.actual}</a>
                                            <div>{item?.date?.d} {item?.date?.time !== "" && item?.date?.time}</div>
                                            <div>{item?.products?.b12 !== 0 && `12.5л: ${item?.products?.b12}`}; {item?.products?.b19 !== 0 && `18.9л: ${item?.products?.b19}`}</div>
                                            <LinkButton
                                                href={`/orderPage/${item?._id}`}
                                            >
                                                Просмотр
                                            </LinkButton>
                                        </div>
                                    </Li>
                                </div>
                            );
                        }
                    })}
                    {loading && <div>Загрузка...</div>}
                </div>

                <Div />
                <Div>Действия:</Div>
                <Div>
                    <div className="flex items-center gap-x-3 flex-wrap">
                        {client?._id && (
                            <LinkButton color="green" href={`/addOrder/${client._id}`}>Создать заказ</LinkButton>
                        )}
                        <MyButton click={getClientOrdersForExcel}>
                            Выгрузить заказы в excel
                        </MyButton>
                        {userData?.role === "superAdmin" && 
                            <MyButton click={() => {setDeleteModalClient(true)}}>Удалить клиента</MyButton>
                        }
                        {userData?.role === "superAdmin" && 
                            <MyButton click={() => {
                                const status = client?.status === "active" ? "inActive" : "active"
                                updateClientData("status", status)}}
                            >{client?.status === "active" ? "Блокировать" : "Активировать"}</MyButton>
                        }
                    </div>
                </Div>
                <Div />
                <MySnackBar
                    open={open}
                    text={message}
                    status={status}
                    close={closeSnack}
                />
            </Container>
        </div>
    );
}
